import { render, staticRenderFns } from "./SignUpPrompt.vue?vue&type=template&id=328038ea&"
import script from "./SignUpPrompt.vue?vue&type=script&lang=js&"
export * from "./SignUpPrompt.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports